import React, { useEffect, useState } from 'react';
import CSVReader from "react-csv-reader";

import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import { makeStyles } from "@material-ui/core/styles";
import AddAlert from "@material-ui/icons/AddAlert";
import Close from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import { Input } from '@material-ui/core';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import SomeSpinner from "components/Somespinner/Somespinner.js"
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Table from "components/Table/Table.js";
import DatePicker from "react-datepicker";
import pt from "date-fns/locale/pt-BR";

import useAuth from "hooks/useAuth";
import api from "assets/services/api";

const useStyles2 = makeStyles(styles2);

const styles = {
  margintp: {
    textAlign: "right",
    marginTop: "10px"
  },
  marginDate: {
    marginBottom: "12px",
    marginTop: "12px",
    display: "flex",
    justifyContent: "center"
  },

  colorCard: {
    color: "#000",
    marginBottom: "-1em",
    fontSize: "14px",
    textAlign: "center"
  },
  marginFor: {
    minHeight: "8em",
    marginTop: "-10px"
  },
  dropDown: {
    width: "80%"
  },
  contentComponent: {
    display: "flex",
    justifyContent: "center",
    textAlign: "center"
  },
  gridContainer: {
    justifyContent: "center"
  }
};

const useStyles = makeStyles(styles);

function ModalAddRouting(props) {
  Date.prototype.withoutTime = function () {
    var d = new Date(this);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  const classes2 = useStyles2();
  const classes = useStyles();

  const { storageId } = useAuth();

  const [br, setBR] = React.useState(false);
  const [controlSnack, setControlSnack] = useState(false);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);

  const [car, setCar] = useState(null);
  const [cars, setCars] = useState(props.cars);

  const [deliveryman, setDeliveryman] = useState(null);
  const [deliverymans, setDeliverymans] = useState(props.deliverymans);

  const [list, setList] = useState([]);
  const [index, setIndex] = useState({ id: 0 });
  const [sells, setSells] = useState([])
  const [weightNf, setWeightNf] = useState(0);

  const showNotification = place => {
    switch (place) {
      case "br":
        if (!br) {
          setBR(true);
          setTimeout(function () {
            setBR(false);
            setControlSnack(false);
          }, 6000);
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (controlSnack) showNotification("br");
  }, [controlSnack]);
  useEffect(() => {
    getSells();
  }, [startDate]);

  useEffect(() => {
    calculateWeight();
  }, [list])

  const calculateWeight = () => {
    let total = 0;
    list.forEach(sell => {
      total += parseFloat(sell.weight);
    });
    setWeightNf(total)
  };

  const getSells = async () => {
    const get_sells = await api.get(`/sells/routing/${storageId}?initDate=${startDate}`);
    let response_sells = [{ nf: 'selecione nf', weight: '0' }];
    for (let i = 0; i < get_sells.data.sells.length; i++) {
      response_sells = [...response_sells, get_sells.data.sells[i]];
    };
    setSells(response_sells);
  };

  const createList = (nf) => {
    if (!nf) return false;
    const new_sell = sells.find((sell) => sell.nf === parseInt(nf.nf));
    const newState = sells.filter((sell) => sell.nf != parseInt(nf.nf));
    setSells(newState);
    const finalList = { nf: new_sell.nf, weight: new_sell.weight };
    setList(prevList => ([...prevList, finalList]));
  };

  const removeList = (sell) => {
    const removeItem = list.filter(item => item.nf != sell.nf)
    setList(removeItem)
    setSells(item => ([...item, sell]))
  };

  function tableData() {
    let table = [];
    for (let i = 0; i < list.length; i++) {
      table[i] = [];
      table[i].push(list[i].nf);
      table[i].push(list[i].weight);
      table[i].push(
        <div className={classes2.tableActions}>
          <Tooltip
            id="tooltip-top-start"
            title="Deletar"
            placement="top"
            classes={{ tooltip: classes2.tooltip }}
          >
            <IconButton
              aria-label="Close"
              className={classes2.tableActionButton}
              onClick={() => { removeList(list[i]) }}
            >
              <Close
                className={
                  classes2.tableActionButtonIcon + " " + classes2.close
                }
              />
            </IconButton>
          </Tooltip>
        </div >);
    };
    return table;
  };

  const createRoute = async () => {
    try {
      if (!car || !deliveryman || list.length === 0) {
        return alert(`Selecione entregador, carro e nf`)
      };
      const response = await api.post('/routing', {
        id_admin: storageId,
        data: list,
        id_deliveryman: deliveryman,
        id_car: car
      })
      if (response.status = 200) {
        props.loadRouting();
        props.onHide();
      }
    } catch (error) {
      return alert(`Erro ao adicionar: ${error}`);
    }
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Adicionar Rota
        </Modal.Title>
      </Modal.Header>
      <Form >
        <Modal.Body>
          <GridContainer>
            <GridItem xs={12} sm={6} md={2}>
              <Card className={classes.marginFor}>
                <div className="d-flex justify-content-center">
                  <CardBody >
                    <p className={classes.colorCard}>Escolher Carro</p>
                  </CardBody>
                </div>
                <div className={classes.marginDate}>
                  <Form.Control onChange={event => setCar(parseInt(event.target.value))} value={car} as="select" className={classes.dropDown} >
                    {cars.map(car => (
                      <option key={String(car.id)} value={car.id}>{car.model}</option>
                    ))}
                  </Form.Control>
                </div>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={2}>
              <Card className={classes.marginFor}>
                <div className="d-flex justify-content-center">
                  <CardBody >
                    <p className={classes.colorCard}>Escolher Entregador</p>
                  </CardBody>
                </div>
                <div className={classes.marginDate}>
                  <Form.Control onChange={event => setDeliveryman(parseInt(event.target.value))} value={deliveryman} as="select" className={classes.dropDown} >
                    {deliverymans.map(deliveryman => (
                      <option key={String(deliveryman.id)} value={deliveryman.id}>{deliveryman.deliverymanname}</option>
                    ))}
                  </Form.Control>
                </div>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={5}>
              <Card className={classes.marginFor}>
                <div className="d-flex justify-content-center">
                  <CardBody >
                    <p className={classes.colorCard}>Notas Fiscas</p>
                  </CardBody>
                </div>
                <div className={classes.marginDate}>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={sells}
                    getOptionLabel={(sell) => `${sell.nf}`}
                    onChange={(e, value) => { createList(value) }}
                    isOptionEqualToValue={(option, value) => option.nf === value}
                    sx={{
                      width: '75%',
                      backgroundColor: "white",
                      borderRadius: "10px",
                      '& .MuiInputBase-root': {
                        height: '40px', // ou o valor desejado
                        fontSize: '14px', // ou o valor desejado                                      
                      }
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                  {/*<Form.Control onChange={event => createList(event.target.value)} value={deliveryman} as="select" className={classes.dropDown} >
                    {sells.map(sell => (
                      <option key={String(sell.nf)} value={sell.nf}>{sell.nf}</option>
                    ))}
                  </Form.Control>*/}
                </div>
                <p className={classes.colorCard}>Selecione uma data</p>
                <div className={classes.marginDate}>
                  <DatePicker
                    className={classes.marginDate}
                    selected={startDate}
                    onChange={(date) => date ? setStartDate(date.withoutTime()) : setStartDate(null)}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Digite ou clique aqui"
                    disabledKeyboardNavigation
                    locale={pt} />
                </div>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <Card className={classes.marginFor}>,
                <div className="d-flex justify-content-center">
                  <CardBody >
                    <p className={classes.colorCard}>Criar Rota</p>
                  </CardBody>
                </div>
                <div className="container" style={{ marginTop: "15px" }}>
                  <div>
                    <div style={{ marginTop: "15px" }}>
                      Peso total produtos: {parseFloat(weightNf).toFixed(2)} <br />
                    </div>
                    <div className="d-flex justify-content-center">
                      <Button color="success" onClick={() => { createRoute() }}>
                        Concluir
                      </Button>
                    </div>
                  </div>
                </div>
              </Card>
            </GridItem>
          </GridContainer>
          <Table
            index={index}
            tableHeaderColor="primary"
            tableHead={["NF", "Peso", "Ação"]}
            tableData={tableData()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Snackbar
            place="br"
            color="success"
            icon={AddAlert}
            message={"Rota criada com sucesso!"}
            open={br}
            closeNotification={() => setBR(false)}
            close
          />

          {loading ?
            <div>
              <SomeSpinner />
            </div> :
            <div></div>
          }
        </Modal.Footer>
      </Form>
    </Modal >
  );
}

export default ModalAddRouting;